import { useMutation, useQueryClient } from 'react-query';
import { message } from 'antd';
import { requestHandler } from './useApi';

/**
 * Hook for canceling a student registration
 */
export const useCancelRegistration = () => {
  const queryClient = useQueryClient();

  return useMutation<any, any, string>(
    // This endpoint strictly accepts a StudentRegistrationWindow ID.
    // CurrentlyScheduling IDs identify a different table and must never be used.
    // requestHandler throws when the API answers with `error: true`.
    (registrationId: string) =>
      requestHandler<any, void>(
        'delete',
        `/v1/auth/reg/register-schedule/cancel/${registrationId}`
      ),
    {
      onSuccess: () => {
        message.success('Registration cancelled successfully');
        // Invalidate related queries
        queryClient.invalidateQueries(['is-enrollment-blocked']);
        queryClient.invalidateQueries(['/v1/auth/reg/is-enrollment-blocked']);

        // Wait a moment before refreshing to show the success message
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      },
      onError: (error: any) => {
        console.error('Failed to cancel registration:', error);

        // More detailed error handling
        if (error?.response) {
          console.error('Error response status:', error.response.status);
          console.error('Error response data:', error.response.data);
          message.error(
            `Failed to cancel registration: ${error.response.data?.message || `HTTP ${error.response.status}`}`
          );
        } else if (error?.request) {
          console.error('Error request:', error.request);
          message.error('Network error: Unable to reach server');
        } else {
          console.error('Error message:', error?.message);
          message.error(
            `Failed to cancel registration: ${error?.message || 'Unknown error'}`
          );
        }
      },
    }
  );
};
